import { replaceCtfassetsImageUrls } from '../../utils/helpers/helpers'

export function withCtfassetsUrlFix<P>(
  WrappedComponent: React.ComponentType<P>,
): React.ComponentType<P> {
  return function CtfassetsUrlFixWrapper(props: P) {
    const { result: transformedProps } = replaceCtfassetsImageUrls(props)
    return <WrappedComponent {...(transformedProps as P)} />
  }
}
